import {
  getFormData,
  submitFormDataViaAPI,
} from './form';
import { setCustomFieldsData } from './custom_fields';

const submitForm = async(form) => {
  const data = getFormData(form);
  const formId = form.attr('id');
  if (data.custom_fields && formId && window.$customFields && window.$customFields[formId]) {
    data.custom_fields = setCustomFieldsData(data.custom_fields, formId);
  }
  await submitFormDataViaAPI(data, form);
};

$(function(){
  $(".simple-submit-form").submit(function(){

    const form = $(this);

    submitForm(form);

    return false;
  });
});

